import { useState, useEffect } from "react"
import { Button, Col, Container, Form, Row, Tabs, Tab } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Select from "react-select";
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'
import Swal from "sweetalert2";

export default function BusinessForm({state,typeBusiness, handleInputChange, handleCheckboxChange, submit, isAddingOrEditing, isRegistering, disableEnableBusinesses}) {
    const { t } = useTranslation()

    const [provinceAux, setProvinceAux] = useState({label: '', value: ''})
    const [townAux, setTownAux] = useState({label: '', value: ''})
    const [townsAux, setTownsAux] = useState([])

    useEffect(() => {
        if (state.addresses) {

            const provAux = []
            const tAux = []
            const townsFiltered = []

            state.addresses.forEach((addr, index) => {

                const selectedProvince = provinces.find(p => p.value === addr.province)
                const selectedTown = towns.find(t => t.value === addr.location)

                provAux[index] = selectedProvince
                    ? { label: selectedProvince.label, value: selectedProvince.value }
                    : null

                tAux[index] = selectedTown
                    ? { label: selectedTown.label, value: selectedTown.value }
                    : null

                townsFiltered[index] = addr.province
                    ? towns.filter(t => t.parent_value === addr.province)
                    : []
            })

            setProvinceAux(provAux)
            setTownAux(tAux)
            setTownsAux(townsFiltered)
        }
    }, [state.addresses])

    const handleSelectProvinceChange = (selected, index) => {
        const updated = [...(state.addresses || [])]
        updated[index].province = selected.value
        updated[index].location = ''

        handleInputChange({
            target: {
                name: 'addresses',
                value: updated
            }
        })

        const newProvinceAux = [...provinceAux]
        newProvinceAux[index] = selected
        setProvinceAux(newProvinceAux)

        const newTownAux = [...townAux]
        newTownAux[index] = null
        setTownAux(newTownAux)

        const newTownsAux = [...townsAux]
        newTownsAux[index] = towns.filter(t => t.parent_value === selected.value)
        setTownsAux(newTownsAux)
    }

    const handleSelectTownChange = (selected, index) => {

        const updated = [...(state.addresses || [])]
        updated[index].location = selected.value

        handleInputChange({
            target: {
                name: 'addresses',
                value: updated
            }
        })

        const newTownAux = [...townAux]
        newTownAux[index] = selected
        setTownAux(newTownAux)
    }

    const handleAddressChange = (index, field, value) => {
        const updated = [...(state.addresses || [])]
        updated[index][field] = value

        handleInputChange({
            target: {
                name: 'addresses',
                value: updated
            }
        })
    }

    const addAddress = () => {
        const updated = [
            ...(state.addresses || []),
            { address: '', location: '', province: '', phone: '', email: '' }
        ]

        handleInputChange({
            target: {
                name: 'addresses',
                value: updated
            }
        })
    }

    const removeAddress = (index) => {
        const updated = [...(state.addresses || [])]
        updated.splice(index, 1)

        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.yes'),
            denyButtonText: t('global.no'),
            icon: 'question',
            text:  t('admin.businesses.areyousuredeleteaddress')
        }).then((deleteAddress) => {
            if (deleteAddress.isConfirmed) {
                handleInputChange({
                    target: {
                        name: 'addresses',
                        value: updated
                    }
                })
            }
        })
    }

    return (
        <Form onSubmit={submit} className="px-4 formulario">
            <Container fluid className="p-0">

                <Tabs defaultActiveKey="general" className="mb-3" fill>

                    {/* ---------------- DATOS GENERALES ---------------- */}
                    <Tab eventKey="general" title={t('admin.businesses.tabGeneral')}>
                        <Row>
                            <Col xs={12} md={3} className="mb-3">
                                <Form.Label>{t('admin.businesses.identifier')}</Form.Label>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='identifier'
                                    value={state.identifier ||  ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Col>
                            <Col xs={12} md={6} className="mb-3">
                                <Form.Label>{t('admin.businesses.name')}</Form.Label>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='name'
                                    value={state.name ||  ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Col>
                            <Col xs={12} md={3} className="mb-3">
                                <Form.Label>{t('admin.businesses.cif')}</Form.Label>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='cif'
                                    value={state.cif ||  ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={4} className="mb-3">
                                <Form.Label>{t('admin.businesses.contact')}</Form.Label>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='contact'
                                    value={state.contact ||  ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                            <Col xs={12} md={4} className="mb-3">
                                <Form.Label>{t('admin.businesses.phone')}</Form.Label>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='phone'
                                    value={state.phone ||  ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                            <Col xs={12} md={4} className="mb-3">
                                <Form.Label>{t('admin.businesses.email')}</Form.Label>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='email'
                                    value={state.email ||  ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12}>
                                <h5 className="sd-form-section">{t('admin.businesses.mainAddress')}</h5>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={6} className="mb-3">
                                <Form.Label>{t('admin.businesses.address')}</Form.Label>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='address'
                                    value={state.address ||  ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                            <Col xs={12} md={2} className="mb-3">
                                <Form.Label>{t('admin.businesses.cp')}</Form.Label>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='cp'
                                    value={state.cp ||  ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                            <Col xs={12} md={2} className="mb-3">
                                <Form.Label>{t('admin.businesses.location')}</Form.Label>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='location'
                                    value={state.location ||  ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                            <Col xs={12} md={2} className="mb-3">
                                <Form.Label>{t('admin.businesses.province')}</Form.Label>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='province'
                                    value={state.province ||  ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} className="mb-3">
                                <Form.Label>{t('admin.businesses.others')}</Form.Label>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='others'
                                    value={state.others ||  ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                    </Tab>

                    {/* ---------------- UBICACIONES DE MUESTREO ---------------- */}
                    <Tab eventKey="locations" title={t('admin.businesses.tabLocations')}>
                        {(state.addresses || []).map((addr, index) => (
                            <div key={index} className="sd-address-card">
                                <div className="sd-address-card-header">
                                    <span className="sd-address-card-title">
                                        {t('admin.businesses.address')} {index + 1}
                                    </span>
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() => removeAddress(index)}
                                    >
                                        <i className="fas fa-trash"></i>
                                    </Button>
                                </div>
                                <Row>
                                    <Col xs={12} md={6} className="mb-3">
                                        <Form.Label>{t('admin.businesses.address')}</Form.Label>
                                        <Form.Control
                                            className="sd-input"
                                            type='text'
                                            value={addr.address || ''}
                                            onChange={(e) =>
                                                handleAddressChange(index, 'address', e.target.value)
                                            }
                                        />
                                    </Col>
                                    <Col xs={12} md={3} className="mb-3">
                                        <Form.Label>{t('admin.businesses.province')}</Form.Label>
                                        <Select
                                            className="select"
                                            classNamePrefix="sd-select"
                                            options={provinces.sort((a, b) =>
                                                a.label.localeCompare(b.label)
                                            )}
                                            value={provinceAux[index] || null}
                                            onChange={(selected) =>
                                                handleSelectProvinceChange(selected, index)
                                            }
                                        />
                                    </Col>
                                    <Col xs={12} md={3} className="mb-3">
                                        <Form.Label>{t('admin.businesses.town')}</Form.Label>
                                        <Select
                                            className="select"
                                            classNamePrefix="sd-select"
                                            options={townsAux[index] || []}
                                            value={townAux[index] || null}
                                            onChange={(selected) =>
                                                handleSelectTownChange(selected, index)
                                            }
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={6} className="mb-3">
                                        <Form.Label>{t('admin.businesses.phone')}</Form.Label>
                                        <Form.Control
                                            className="sd-input"
                                            type='text'
                                            value={addr.phone || ''}
                                            onChange={(e) =>
                                                handleAddressChange(index, 'phone', e.target.value)
                                            }
                                        />
                                    </Col>
                                    <Col xs={12} md={6} className="mb-3">
                                        <Form.Label>{t('admin.businesses.email')}</Form.Label>
                                        <Form.Control
                                            className="sd-input"
                                            type='text'
                                            value={addr.email || ''}
                                            onChange={(e) =>
                                                handleAddressChange(index, 'email', e.target.value)
                                            }
                                        />
                                    </Col>
                                </Row>
                            </div>
                        ))}

                        <Button variant="secondary" size="sm" onClick={addAddress}>
                            <i className="fas fa-plus me-1"></i>
                            {t('admin.businesses.addAddress')}
                        </Button>
                    </Tab>

                    {/* ---------------- EVALUACIÓN (solo proveedor) ---------------- */}
                    {typeBusiness === 'provider' &&
                        <Tab eventKey="evaluation" title={t('admin.businesses.tabEvaluation')}>
                            <Row>
                                <Col xs={12} md={4} className="mb-3">
                                    <Form.Label>{t('admin.businesses.qualitySystem')}</Form.Label>
                                    <Form.Control
                                        className="sd-input"
                                        type='text'
                                        name='qualitySystem'
                                        value={state.qualitySystem ||  ''}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                                <Col xs={12} md={4} className="mb-3">
                                    <Form.Label>{t('admin.businesses.evaluationStatus')}</Form.Label>
                                    <Form.Control
                                        className="sd-input"
                                        type='text'
                                        name='evaluationStatus'
                                        value={state.evaluationStatus ||  ''}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                                <Col xs={12} md={4} className="mb-3">
                                    <Form.Label>{t('admin.businesses.evaluationDate')}</Form.Label>
                                    <Form.Control
                                        className="sd-input"
                                        type='date'
                                        name='evaluationDate'
                                        value={state.evaluationDate ? new Date(state.evaluationDate).toISOString().split('T')[0] : ''}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={6} className="mb-3">
                                    <Form.Label>{t('admin.businesses.evaluated')}</Form.Label>
                                    <Form.Check
                                        type='checkbox'
                                        name='evaluated'
                                        checked={state.evaluated ||  false}
                                        onChange={handleCheckboxChange}
                                    />
                                </Col>
                                <Col xs={12} md={6} className="mb-3">
                                    <Form.Label>{t('admin.businesses.evaluationCriteria')}</Form.Label>
                                    <Form.Control
                                        className="sd-input"
                                        type='text'
                                        name='evaluationCriteria'
                                        value={state.evaluationCriteria ||  ''}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={6} className="mb-3">
                                    <Form.Label>{t('admin.businesses.certification')}</Form.Label>
                                    <Form.Control
                                        className="sd-input"
                                        type='text'
                                        name='certification'
                                        value={state.certification ||  ''}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                                <Col xs={12} md={6} className="mb-3">
                                    <Form.Label>{t('admin.businesses.services')}</Form.Label>
                                    <Form.Control
                                        className="sd-input"
                                        type='text'
                                        name='services'
                                        value={state.services ||  ''}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={6} className="mb-3">
                                    <Form.Label>{t('admin.businesses.responsible')}</Form.Label>
                                    <Form.Control
                                        className="sd-input"
                                        type='text'
                                        name='responsible'
                                        value={state.responsible ||  ''}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                                <Col xs={12} md={6} className="mb-3">
                                    <Form.Label>{t('admin.businesses.area')}</Form.Label>
                                    <Form.Control
                                        className="sd-input"
                                        type='text'
                                        name='area'
                                        value={state.area ||  ''}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                            </Row>
                        </Tab>
                    }

                </Tabs>

                {/* ---------------- PIE: activar/desactivar + guardar ---------------- */}
                <Row className="mt-3">
                    <Col xs={6}>
                        {isAddingOrEditing === 'editing' && (
                            <Button variant="fourth" className="mb-3" onClick={(e) => disableEnableBusinesses(e)}>
                                {state?.active
                                ?
                                <><i className="fas fa-ban me-2"></i> {t('global.disable')}</>
                                :
                                <><i className="fas fa-check me-2"></i> {t('global.enable')}</>
                                }
                            </Button>
                        )}
                    </Col>
                    <Col xs={6} className="d-flex justify-content-end">
                        <Button variant='primary' type="submit" className="mb-3">
                        {isRegistering
                            ?
                                <>
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </>
                            :
                                isAddingOrEditing === 'editing'
                                ?
                                <><i className="fas fa-edit me-2"></i> {t('global.edit')}</>
                                :
                                <>{t('global.register')}</>
                        }
                        </Button>
                    </Col>
                </Row>

            </Container>
        </Form>
    )
}
